import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import parse from "html-react-parser";
import './disclaimer.scss';

const Disclaimer = ({ activeSubmenu }) => {
    const [disclaimerData, setDisclaimerData] = useState([]);
    useEffect(() => {
        const selectedProductType =
            window.selectedConfig?.ProductType?.toLowerCase();

        let disclaimer = [];

        // 1. Try finding a submenu first
        const submenu = window.config?.allSubmenu?.find(
            item => item.id === activeSubmenu
            
        );
        // console.log("submenu:", submenu);
        if (submenu) {
            disclaimer = submenu.disclaimer || [];
            // console.log(disclaimer, "disclaimer");
        } else {
            // 2. Otherwise search all hotspots
            const hotspot = window.config?.allSubmenu
                ?.flatMap(menu => menu.hotspotDataInfo || [])
                .find(
                    hs =>
                        hs.id === activeSubmenu ||
                        hs.hsname === activeSubmenu
                );

            disclaimer = hotspot?.disclaimer || [];
            // console.log(disclaimer, "disclaimer");
        }

        const filteredDisclaimers = disclaimer.filter(sw => {
            if (!sw.configType || !sw.configType.ProductType) return true;

            return sw.configType.ProductType
                .map(p => p.toLowerCase())
                .includes(selectedProductType);
        });

        setDisclaimerData(filteredDisclaimers);
    }, [activeSubmenu]);
    const container = document.getElementById("menuDisclaimerContainer");
    if (!container) return null;


    const content = (
        <div className={`disclaimerWrapper ${window.isMobIsipadIsPotrait ? "mobile" : "desktop"}`}
            id={activeSubmenu}
        >
            {disclaimerData.map((item, index) => (
                <p key={index}>
                    {parse(
                        item.text
                            .replace(/&lt;br\s*\/?&gt;/gi, "<br />")
                            .replace(/<\/br>/gi, "<br />")
                    )}
                </p>

            ))}
        </div>
    );

    // Mobile: render inline, Desktop: portal
    if (window.isMobIsipadIsPotrait) {
        return ReactDOM.createPortal(content, container); // portal for desktop
    } else {
        return ReactDOM.createPortal(content, container); // portal for desktop
    }
};

export default Disclaimer;
